import { setupCommentForm } from "./commentForm";
setupCommentForm();
